import {PlanKey} from "./tariffs.interface";

export interface IPayOption {
  payOption: PlanKey;
  discountCode: string;
  tokensCount: number;
}
